import { shallowMount } from "@vue/test-utils";
import ContinuaSucursal from "@/views/ContinuaSucursal";

describe("ContinuaSucursal component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ContinuaSucursal);
  });

  it("Renders del component ContinuaSucursal", () => {
    expect(wrapper).toBeDefined();
  });
});
